// Settings of the exposure layer ("Population baseline"). Rule R2 of the exposure spec lives in
// services/exposureApi.ts; the numbers it needs are here.

/** The year of the population and workplace grids. */
export const EXPOSURE_YEAR = 2025;

/**
 * Share of residents who are away at work or school on a weekday daytime. An assumption, not a
 * register figure; it is tagged "assumption" wherever a figure depends on it.
 */
export const AWAY_SHARE = 0.5;

export const EXPOSURE_SOURCE = {
  name: 'Statistisk sentralbyrå (SSB)',
  licence: 'NLOD',
  population: 'population 250 m 2025',
  workplaces: 'workplaces 250 m 2025',
} as const;

/** Side of a grid cell in the SSB 250 m population and workplace grids, in metres. */
export const CELL_SIZE_M = 250;

/** The most cells the cell layer draws. Above this the layer says the area is too large. */
export const BASELINE_CELL_CAP = 5000;

/** Credit shown while the cell layer is on. */
export const BASELINE_ATTRIBUTION = `© ${EXPOSURE_SOURCE.name}, ${EXPOSURE_SOURCE.licence}`;
